module.exports = __webpack_public_path__ + "assets/img/7eb002c95b628239ca05b37438b03f93.png";